// extracted by mini-css-extract-plugin
export default {"newApp":"newApp--kgeRY"};